import { Col, Row, Table } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import Services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { useEffect, useRef, useState } from "react";
import Layout from "../../layout";
import { useDownloadExcel } from "react-export-table-to-excel";
import moment from "moment";
import ReactGA from "react-ga4";
import FoodPaymentReport from "./FoodPaymentReport";
import { mainUrl } from 'API/client/api';
import axios from "axios";

let foodTax = 2.5;
const STORY_HEADERS = [
  {
    prop: "sn",
    title: "SN.",
    cell: (row) => `${row?.sn ?? "N/A"}`,
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "id",
    title: "Order ID",
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "ncType",
    title: "KOT Type",
    // isSortable: true,
    // isFilterable: true,
    cell: (row) => row?.ncType,
  },
  {
    prop: "orderItems",
    title: "Items Ordered",
    // isSortable: true,
    // isFilterable: true,
    cell: (row) => row?.orderItems,
  },
  {
    prop: "orderNote",
    title: "Order Notes",
    // isSortable: true,
    // isFilterable: true,
    cell: (row) => row?.orderNote ? row?.orderNote : '-',
  },
  {
    prop: "BookingHotel[bookingCode]",
    title: "Booking ID",
    cell: (row) => `${row?.bookingCode ?? "N/A"}`,
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "roomNumber",
    title: "Room No",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row?.roomNumber
  },
  {
    prop: "guestName",
    title: "Guest Name",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row?.guestName
  },
  {
    prop: "createdAt",
    title: "Order Date & Time",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => {
      const [rawDate, user] = (row?.createdAt || "").split(" - ");
      const formatted = moment.utc(rawDate.trim(), "DD/MM/YYYY, HH:mm:ss")
        .utcOffset("+05:30")
        .format("DD-MM-YYYY HH:mm:ss");

      return `${formatted} - ${user?.trim() || "N/A"}`;
    }
  },
  {
    prop: "orderAccepted",
    title: "Order Accepted",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => {
      if (!row?.orderAccepted) return "N/A";
      const [rawDate, user] = row.orderAccepted.split(" - ");
      const formatted = moment
        .utc(rawDate.trim(), "DD/MM/YYYY, HH:mm:ss")
        .utcOffset("+05:30")
        .format("DD-MM-YYYY HH:mm:ss");

      return `${formatted} - ${user?.trim() || "N/A"}`;
    }
  },
  {
    prop: "orderDelivered",
    title: "Order Deliver",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => {
      if (!row?.orderDelivered) return "N/A";
      const [rawDate, user] = row.orderDelivered.split(" - ");
      const formatted = moment
        .utc(rawDate.trim(), "DD/MM/YYYY, HH:mm:ss")
        .utcOffset("+05:30")
        .format("DD-MM-YYYY HH:mm:ss");

      return `${formatted} - ${user?.trim() || "N/A"}`;
    }
  },
  {
    prop: "orderAmount",
    title: "Amount",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) =>
      `₹${(
        row?.orderAmount -
        row?.orderAmount * ((foodTax + foodTax) / 100)
      )?.toFixed(2)}`,
  },
  {
    prop: "orderStatus",
    title: "Order Status",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row?.orderStatus
  },
];

const tabsData = [
  { id: 0, name: "Food Report" },
  { id: 1, name: "Food Payment Report" },
  { id: 2, name: "Food Item Report" },
  { id: 3, name: "Most Selling Food Items" },
]

// Then, use it in a component.
export default function FoodReport() {

  const { userDetail } = useSelector(authenticationSeletor);
  const [tableData, setTableData] = useState([]);
  const [exportFilter, setExportFilter] = useState({
    startDate: (() => {
      const d = new Date();
      d.setMonth(d.getMonth() - 1);
      return d;
    })(),
    endDate: new Date(),
  });
  const [searchBookingId, setSearchBookingId] = useState('');
  const [searchOutletId, setSearchOutletId] = useState('');
  const [debouncedBookingId, setDebouncedBookingId] = useState('');
  const [debouncedOutletId, setDebouncedOutletId] = useState('');
  const [selectedTab, setSelectedTab] = useState(0)
  const [topSellingFood, setTopSellingFood] = useState([])

  const tableRef = useRef();
  const { access_token } = useSelector((state) => state.authentication);

  const getDataHandler = async () => {
    const payload = {
      fromdate: moment(exportFilter.startDate).format("YYYY-MM-DD 00:00:00"),
      todate: moment(exportFilter.endDate).format("YYYY-MM-DD 23:59:59"),
      propertyId: userDetail?.propertyId,
    };
    if (searchBookingId) { payload.booking_id = searchBookingId }
    if (searchOutletId) { payload.orderId = searchOutletId }
    try {
      const res = await Services.property.getFoodOrdersByPropertyId(payload)
      if (res.status == 200) {
        const resultWithSN = res.data.data.map((item, index) => ({ ...item, SN: index + 1 }));
        setTableData(resultWithSN);
      }
    } catch (error) { console.log("Error in getDataHandler funtion.") }
  };

  useEffect(() => { getDataHandler(); }, [exportFilter.startDate, exportFilter.endDate, debouncedBookingId, debouncedOutletId])

  useEffect(() => {
    const handler = setTimeout(() => { setDebouncedBookingId(searchBookingId); }, 500);
    return () => clearTimeout(handler);
  }, [searchBookingId]);

  useEffect(() => {
    const handler = setTimeout(() => { setDebouncedOutletId(searchOutletId); }, 500);
    return () => clearTimeout(handler);
  }, [searchOutletId]);

  useEffect(() => { ReactGA.send({ hitType: "pageview", page: "food_reporting" }); }, []);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Food_Orders_Details",
    sheet: "Food_Orders_Details",
  });

  const getTopSellingFoodItem = async () => {
    try {
      let newFromDate = moment(exportFilter.startDate).format("YYYY-MM-DD")
      let newToDate = moment(exportFilter.endDate).format("YYYY-MM-DD")
      const queryParams =
        newFromDate && newToDate ? `?fromDate=${encodeURIComponent(newFromDate)}&toDate=${encodeURIComponent(newToDate)}` : "";
      let res = await axios.get(`${mainUrl}api/rrooms-property/most-selling-food/${userDetail?.propertyId}${queryParams}`)
      if (res?.data?.status) {
        setTopSellingFood(res?.data?.data)
      }
    } catch (error) {
      console.log("Error in getTopSellingFoodItem function.")
    }
  }

  useEffect(() => {
    if (selectedTab == 3) {
      getTopSellingFoodItem()
    }
  }, [selectedTab, exportFilter.endDate])

  const exportHandler = async () => {
    const payload = {
      fromdate: moment(exportFilter.startDate).format("YYYY-MM-DD 00:00:00"),
      todate: moment(exportFilter.endDate).format("YYYY-MM-DD 23:59:59"),
      propertyId: userDetail?.propertyId,
    };

    if (searchBookingId) {
      payload.booking_id = searchBookingId;
    }

    if (searchOutletId) {
      payload.orderId = searchOutletId;
    }

    if (selectedTab == 0) {
      fetch(`${mainUrl}api/rrooms-property/food-order-report-export`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Food-Order-Report.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        });
    }

    if (selectedTab == 1) {
      fetch(`${mainUrl}api/rrooms-property/food-payment-report-export`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Food-Order-Payment-Report.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        });
    }

    if (selectedTab == 3) {
      let fromdate = moment(exportFilter.startDate).format("YYYY-MM-DD");
      let todate = moment(exportFilter.endDate).format("YYYY-MM-DD")
      const queryParams =
        fromdate && todate ? `?fromDate=${encodeURIComponent(fromdate)}&toDate=${encodeURIComponent(todate)}` : "";
      fetch(`${mainUrl}api/rrooms-property/export-most-selling-food/${payload?.propertyId}${queryParams}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "application/json"
        }
      })
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Top-Selling-Food-Items.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        });
    }
  };

  return (
    <Layout
      title="Food Report"
      extraBtnHandler={exportHandler}
      extraButton="Export Table"
      setFromDate={(date) => setExportFilter({ ...exportFilter, startDate: date })}
      searchfilter={true}
      setToDate={(date) => setExportFilter({ ...exportFilter, endDate: date })}
      dateFilter={exportFilter}
      searchType={"date"}
      fromDate={exportFilter.startDate}
      toDate={exportFilter.endDate}
    >

      {
        userDetail?.logintype == "propertyUser" &&
        <div className="r-tabs flex justify-content-between">
          <ul className="d-flex align-items-center mb-0">
            {
              tabsData?.map((item) => (
                <li
                  key={item?.id}
                  className={item?.id == selectedTab ? 'active' : ''}
                  onClick={() => setSelectedTab(item?.id)}>
                  {item?.name}
                </li>
              ))
            }
          </ul>
        </div>
      }

      {
        selectedTab == 0 &&
        <Row className="justify-content-end" style={{ marginTop: '-36px' }}>
          <DatatableWrapper
            body={tableData}
            headers={STORY_HEADERS}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 20,
                options: [5, 10, 15, 20, 50, 100, 300],
              },
            }}
          >
            <div className="col-lg-8 mb-2">
              <div className="row-sm d-flex justify-content-end">
                <div className="col-lg-2">
                  <input
                    type="text"
                    className="field-control sm border-dark"
                    value={searchBookingId}
                    onChange={(e) => {
                      setSearchBookingId(e.target.value);
                      setSearchOutletId('')
                    }}
                    placeholder="Search By Booking Id" />
                </div>
                <div className="col-lg-2">
                  <input
                    type="text"
                    className="field-control sm border-dark"
                    value={searchOutletId}
                    onChange={(e) => {
                      setSearchOutletId(e.target.value);
                      setSearchBookingId('')
                    }}
                    placeholder="Search By Order Id" />
                </div>
                <div className="col-lg-1 ">
                  <PaginationOptions />
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <Table className="food-report" ref={tableRef}>
                <TableHeader />
                <TableBody />
              </Table>
            </div>
            <Col className="d-flex flex-col justify-content-end align-items-end paginationFoodReport">
              <Pagination />
            </Col>
          </DatatableWrapper>
        </Row>
      }

      {
        selectedTab == 1 &&
        <FoodPaymentReport />
      }

      {
        selectedTab == 3 &&
        <table className="food-report table">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Total Quantity</th>
              <th>Total Revenue</th>
            </tr>
          </thead>
          <tbody>
            {topSellingFood?.length ?
              topSellingFood?.map((v) => {
                return (<tr>
                  <td>{v?.itemName}</td>
                  <td>{v?.totalQty}</td>
                  <td>{v?.totalRevenue}</td>
                </tr>)
              }) : <tr>
                <td></td>
                <td>No Data Found!</td>
                <td></td>
              </tr>}
          </tbody>
        </table>
      }

    </Layout>
  );
}
